<template>
  <a-spin :spinning="loading" tip="در حال ثبت اطلاعات">
    <a-list :locale="{emptyText:'رکوردی وجود ندارد.'}" bordered item-layout="horizontal">
      <a-list-item class="grid grid-cols-3" v-for="(item,index) in training" :key="index">
        <div>
          <a-button v-if="item.file" target="_blank" type="primary"
                    :disabled="!$getAccess('personnel.train.download')" :href="item.file.storage"
                    class="mr-3">دانلود پیوست
          </a-button>
          <a-tooltip placement="bottomRight">
            <template slot="title">
              <span>حذف</span>
            </template>
            <a-popconfirm
                :disabled="!$getAccess('personnel.train.delete')"
                placement="right"
                title="آیا می خواهید حذف کنید؟"
                ok-text="بله"
                cancel-text="خیر"
                @confirm="removeEdu(item)"
            >
              <a-button type="danger" class="mr-3">حذف</a-button>
            </a-popconfirm>
          </a-tooltip>
        </div>
        <div><span>دسته گواهینامه :</span> {{ item.type }}</div>
        <div style="direction: rtl">عنوان گواهینامه : {{ item.title }}</div>
      </a-list-item>
    </a-list>
    <a-button :disabled="!$getAccess('personnel.train.create')" class="mt-4 ml-2"
              @click="showAddEducationalInformation=true;isAlertUpload = false">افزودن ردیف
    </a-button>

    <a-modal forceRender okText="ایجاد" cancelText="بستن" v-model="showAddEducationalInformation"
             title="افزودن اطلاعات آموزشی" @ok="addEdu">
      <a-form :form="fromEducationalInformation">
        <div class="grid sm:grid-cols-1 md:grid-cols-2 md:gap-4 lg:grid-cols-2 lg:gap-4">
          <a-form-item label="دسته گواهینامه">
            <!--<input class="ant-input"    autocomplete="off" v-decorator="['type',{rules: [{ required: true, message: 'وارد کردن شغل الزامی است' }]}]"/>-->
            <a-select style="width: 100%"
                      v-decorator="['type',{rules: [{ required: true, message: 'وارد کردن شغل الزامی است' }]}]">
              <a-select-option v-for="(item,index) in category" :value="item">
                {{ item }}
              </a-select-option>
              <!--<a-select-option value="lucy">
                Lucy
              </a-select-option>
              <a-select-option value="disabled" disabled>
                Disabled
              </a-select-option>
              <a-select-option value="Yiminghe">
                yiminghe
              </a-select-option>-->
            </a-select>
          </a-form-item>
          <a-form-item label="عنوان گواهینامه">
            <input class="ant-input" autocomplete="off"
                   v-decorator="['title',{rules: [{ required: true, message: 'وارد کردن شغل الزامی است' }]}]"/>
          </a-form-item>
        </div>
        <a-form-item label="فایل">
          <div class="dropbox">
            <a-upload-dragger
                v-if="!isAlertUpload"
                :customRequest="uploadImage"
                :show-upload-list="false"
                :before-upload="beforeUpload">
              <p class="ant-upload-drag-icon">
                <a-icon type="inbox"/>
              </p>
              <p class="ant-upload-text">
                فایل را درگ کنید یا اینکه کاوش کنید.
              </p>
              <p class="ant-upload-hint">
                فایل را درگ کنید یا اینکه کاوش کنید.
              </p>
            </a-upload-dragger>
            <div v-else>
              <a-alert message="آپلود سند با موفقیت انجام شد." type="success"/>
            </div>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>

  </a-spin>
</template>

<script>
import axios from "@/axios";

export default {
  name: "training",
  props: {
    training: Array,
    uploadImage: Function,
    beforeUpload: Function,
    value: [Object,null]
  },
  data() {
    return {
      loading: false,
      showAddEducationalInformation: false,
      isAlertUpload: false,
      fromEducationalInformation: this.$form.createForm(this, {name: 'cordinate'}),
      category: [],
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  methods: {
    async removeEdu(item) {
      if (item.id) {
        try {
          await axios.post('/personnel/remove-traning', {id: item.id});
          this.$emit('update')
        } catch (e) {
           console.log(e);
        }
      } else {
        const index = this.training.indexOf(item);
        this.training.splice(index, 1);
      }
    },
    addEdu(e) {
      e.preventDefault();
      this.fromEducationalInformation.validateFields(async(err, values) => {
        if (!err) {
          let training = this.training
          if (this.value) {
            values.file_id = this.value.id
            values.file = this.value.storage
          }
          training.push(values);
          this.showAddEducationalInformation = false;
          this.$message.success('اطلاعات با موفقیت ثبت شد');
          this.fromEducationalInformation.resetFields();
          this.$emit('input',null)
          await this.saveData(training);
        } else {
          this.$ntGetError('اطلاعات را به صورت کامل وارد کنید');
        }
      });
    },
    async saveData(training) {
      if (training) {
        try {
          this.loading = true
          let values = {
            training: training,
            id: this.id
          }
          values.documents = this.documents;
          if (!this.$getAccess('personnel.train')) {
            values.training = this.training
          }
          await axios.post('/personnel/training/update', values);
          this.$emit('update')
          this.$ntSet()
        } catch (e) {
          this.$ntSetError()

      console.log(e)
        } finally {
          this.loading = false
          this.showAddEducationalInformation = false
        }
      }
      else {
        this.$ntGetError('اطلاعات را به صورت کامل وارد کنید');
      }
    },
  },
  async created() {
    try {
      this.loading = true
      const {data} = await axios.get('/get-category')
      this.category = data
    } catch (e) {
      this.$message.error('خطا در دریافت اطلاعات');
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>